exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable[data-v-3198ad42] {\n  cursor: pointer;\n}\n.timeline-image[data-v-3198ad42] {\n  border-radius: 50%;\n}\n.timeline-image-badge[data-v-3198ad42] {\n  background-color: transparent !important;\n}\n", ""]);

// exports
